// ============================================================
// Full IT/EN string table — lifted verbatim from reference/data.js (S).
// Every translatable label, button, helper text, status name lives here.
// Use the `t()` helper to read a key.
// ============================================================
import type { StringTable } from '../data/types';

export const S: StringTable = {
  nav_service: { it: 'Servizio', en: 'Service' },
  nav_clients: { it: 'Clienti', en: 'Clients' },
  nav_settings: { it: 'Configurazione', en: 'Setup' },
  cal: { it: 'Calendario', en: 'Calendar' },
  bookings: { it: 'Prenotazioni', en: 'Bookings' },
  customers: { it: 'Clienti', en: 'Customers' },
  availability: { it: 'Disponibilità', en: 'Availability' },
  tables: { it: 'Tavoli', en: 'Tables' },
  notifications: { it: 'Notifiche', en: 'Notifications' },
  settings: { it: 'Impostazioni', en: 'Settings' },
  website: { it: 'Sito web', en: 'Website' },
  insights: { it: 'Andamento', en: 'Insights' },
  today: { it: 'Oggi', en: 'Today' },
  timeline: { it: 'Timeline', en: 'Timeline' },
  agenda: { it: 'Agenda', en: 'Agenda' },
  floor: { it: 'Sala', en: 'Floor' },
  newResv: { it: 'Nuova prenotazione', en: 'New booking' },
  search: { it: 'Cerca per nome, telefono…', en: 'Search name, phone…' },
  covers: { it: 'coperti', en: 'covers' },
  cover: { it: 'coperto', en: 'cover' },
  seats: { it: 'posti', en: 'seats' },
  guests: { it: 'ospiti', en: 'guests' },
  table: { it: 'Tavolo', en: 'Table' },
  free: { it: 'Libero', en: 'Free' },
  st_new: { it: 'Da confermare', en: 'To confirm' },
  st_conf: { it: 'Confermata', en: 'Confirmed' },
  st_seated: { it: 'In sala', en: 'Seated' },
  st_done: { it: 'Completata', en: 'Completed' },
  st_noshow: { it: 'No-show', en: 'No-show' },
  st_cancel: { it: 'Annullata', en: 'Cancelled' },
  src_web: { it: 'Sito', en: 'Web' },
  src_guest: { it: 'Ospite', en: 'Guest' },
  src_phone: { it: 'Telefono', en: 'Phone' },
  src_walkin: { it: 'Walk-in', en: 'Walk-in' },
  tag_vip: { it: 'VIP', en: 'VIP' },
  tag_regular: { it: 'Habitué', en: 'Regular' },
  tag_allergy: { it: 'Allergia', en: 'Allergy' },
  all: { it: 'Tutte', en: 'All' },
  confirm: { it: 'Conferma', en: 'Confirm' },
  seat: { it: 'Fai accomodare', en: 'Seat now' },
  message: { it: 'Messaggio', en: 'Message' },
  cancel: { it: 'Annulla', en: 'Cancel' },
  phone: { it: 'Telefono', en: 'Phone' },
  note: { it: 'Nota', en: 'Note' },
  source: { it: 'Origine', en: 'Source' },
  time: { it: 'Orario', en: 'Time' },
  party: { it: 'Coperti', en: 'Party' },
  status: { it: 'Stato', en: 'Status' },
  guest_label: { it: 'Cliente', en: 'Guest' },
  history: { it: 'Storico', en: 'History' },
  visits: { it: 'visite', en: 'visits' },
  avg: { it: 'media', en: 'avg' },
  lastVisit: { it: 'Ultima visita', en: 'Last visit' },
  favourite: { it: 'Piatto preferito', en: 'Favourite' },
  email: { it: 'Email', en: 'Email' },
  name: { it: 'Nome', en: 'Name' },
  pending: { it: 'In attesa', en: 'Pending' },
  coversToday: { it: 'Coperti, oggi', en: 'Covers, today' },
  occupancy: { it: 'Occupazione', en: 'Occupancy' },
  noshowRate: { it: 'No-show, mese', en: 'No-show, month' },
  bookingsToday: { it: 'Prenotazioni oggi', en: 'Bookings today' },
  coversByDay: { it: 'Coperti per giorno', en: 'Covers by day' },
  thisWeek: { it: 'questa settimana', en: 'this week' },
  bookingSources: { it: 'Da dove arrivano', en: 'Where bookings come from' },
  topRegulars: { it: 'Habitué', en: 'Top regulars' },
  openHours: { it: 'Orari di apertura', en: 'Opening hours' },
  bookingFollowsHours: {
    it: 'Le prenotazioni seguono i tuoi orari di apertura.',
    en: 'Bookings follow your opening hours.',
  },
  editInWebsite: { it: 'Modifica in Sito web', en: 'Edit in Website' },
  hoursNotSet: {
    it: 'Orari non ancora impostati — aggiungili nel tuo Sito web.',
    en: 'Hours not set yet — add them in your Website.',
  },
  closed: { it: 'Chiuso', en: 'Closed' },
  areas: { it: 'Aree e tavoli', en: 'Areas & tables' },
  turnTime: { it: 'Durata media tavolo', en: 'Average table turn' },
  minutes: { it: 'minuti', en: 'minutes' },
  bizName: { it: 'Nome attività', en: 'Business name' },
  bookingRules: { it: 'Regole di prenotazione', en: 'Booking rules' },
  branding: { it: 'Brand del portale', en: 'Portal branding' },
  brandingSub: { it: 'Come appare il portale prenotazioni ai vostri clienti.', en: 'How the booking portal looks to your customers.' },
  guestBooking: { it: 'Prenotazione ospite', en: 'Guest booking' },
  guestBookingSub: { it: 'I clienti possono prenotare senza creare un account.', en: 'Customers can book without creating an account.' },
  autoConfirm: { it: 'Conferma automatica', en: 'Auto-confirm' },
  autoConfirmSub: { it: 'Conferma subito le richieste sotto i {n} coperti.', en: 'Instantly confirm requests under {n} covers.' },
  addArea: { it: 'Aggiungi area', en: 'Add area' },
  editArea: { it: 'Modifica area', en: 'Edit area' },
  newArea: { it: 'Nuova area', en: 'New area' },
  areaName: { it: 'Nome area', en: 'Area name' },
  tablesCount: { it: 'Tavoli', en: 'Tables' },
  seatsCount: { it: 'Posti', en: 'Seats' },
  deleteArea: { it: 'Elimina area', en: 'Delete area' },
  bookableOnline: { it: 'Prenotabile online', en: 'Bookable online' },
  emailNotif: { it: 'Notifiche email', en: 'Email notifications' },
  emailNotifSub: { it: 'Conferme e promemoria automatici per voi e per i clienti.', en: 'Automatic confirmations & reminders for you and guests.' },
  save: { it: 'Salva modifiche', en: 'Save changes' },
  general: { it: 'Generale', en: 'General' },
  noBookings: { it: 'Nessuna prenotazione', en: 'No bookings' },
  request: { it: 'richiesta', en: 'request' },
  requests: { it: 'richieste', en: 'requests' },
  edit: { it: 'Modifica', en: 'Edit' },
  markAllRead: { it: 'Segna tutte come lette', en: 'Mark all read' },
  poweredNote: { it: 'Sito e portale di', en: 'Site & portal by' },
  online: { it: 'online', en: 'live' },
  arrivingNow: { it: 'In arrivo ora', en: 'Arriving now' },
  vsLastWeek: { it: 'vs settimana scorsa', en: 'vs last week' },
  ofCapacity: { it: 'della capienza', en: 'of capacity' },
  open: { it: 'aperte', en: 'open' },
};
